// extracted by mini-css-extract-plugin
module.exports = {"root":"InTileFooterSash_root__1hYGn","text":"InTileFooterSash_text__2sbv4","topSash":"InTileFooterSash_topSash__1wUtj","spinAround":"InTileFooterSash_spinAround__vkBSN"};